export const QUERY_KEYS = {
  GET_AVAILABILITY_KEY: 'availability',
  GET_AVAILABILITY_ENUMS_KEY: 'availability-enums',
  GET_BILLING_KEY: 'billing',
  GET_BILLING_TASK_KEY: 'billing-task',
  GET_BILLING_INSTACAR_KEY: 'billing-instacar',
  GET_BILLING_INSTARIDE_KEY: 'billing-instaride',
  GET_BILLING_REFUNDS_KEY: 'billing-refunds',
  GET_BILLING_DAMAGES_KEY: 'billing-damages',
  GET_BILLING_OTHER_KEY: 'billing-other',
  GET_BILLING_ASSIGNEES_KEY: 'billing-assignees',
  GET_CAMPAIGNS_KEY: 'campaigns',
  GET_CAMPAIGN_KEY: 'campaign',
  GET_VEHICLE_BY_INTERNAL_ID_KEY: 'vehicle-by-internal-id',
  GET_ARNM_REPAIRS_TASKS_KEY: 'arnmRepairs-tasks',
  GET_ARNM_REPAIRS_TASK_KEY: 'arnmRepairs-task',
  GET_ARNM_MAINTENANCE_TASK_KEY: 'arnmMaintenance-task',
  GET_ARNM_ACCIDENTS_KEY: 'arnmAccidents',
  GET_ARNM_ACCIDENTS_TASK_KEY: 'arnmAccidents-task',
  GET_ORDERS_KEY: 'orders-listing',
  GET_LOGGER_KEY: 'error-list',
  GET_AGENTS_KEY: 'agents',
  GET_PARTNERS_KEY: 'partners',
  GET_USERS_KEY: 'users-list',
  GET_USERS_B2B_ORDERS_KEY: 'users-b2b-orders',
  GET_PERMISSIONS_KEY: 'permissions',
  GET_CONFIGURATION_KEY: 'configuration',
  GET_ROADSIDE_ASSISTANCE_KEY: 'roadside-assistance',
  GET_ROADSIDE_ASSISTANCES_KEY: 'roadside-assistances',
  GET_RESERVATION_KEY: 'reservation',
  GET_RESERVATION_HISTORY_KEY: 'reservation-history',
  GET_RESERVATIONS_KEY: 'reservations',
  GET_RESERVATIONS_ENUMS_KEY: 'reservations-enums',
  GET_SERVICE_POINT_KEY: 'service-point',
  GET_SERVICE_POINTS_KEY: 'service-points',
  GET_SERVICE_POINTS_ENUMS_KEY: 'service-points-enums',
  GET_DEFLEET_KEY: 'defleet',
  GET_DEFLEET_TASK_KEY: 'defleet-task',
  GET_DEFLEET_USER_KEY: 'defleet-user',
  GET_TEAMS_KEY: 'teams',
  GET_TEAM_KEY: 'team',
  GET_INSURANCE_KEY: 'insurance',
  GET_INSURANCES_KEY: 'insurances',
  GET_PRODUCTS_KEY: 'products',
  GET_PRODUCT_KEY: 'product',
  GET_VENDORS_KEY: 'vendors',
  GET_VENDOR_KEY: 'vendor',
  GET_SELL_REQUESTS_KEY: 'sell-requests',
  GET_SELL_REQUESTS_TASK_KEY: 'sell-requests-task',
  GET_BOARDS_ENUMS: 'boards-enums',
  GET_GREEN_CARD_KEY: 'green-card',
  GET_GREEN_CARD_TASK_KEY: 'green-card-task',
  GET_SERVICE_VEHICLE_KEY: 'service-vehicle',
  GET_SERVICE_VEHICLES_KEY: 'service-vehicles',
  GET_SERVICE_VEHICLES_TYPES_KEY: 'service-vehicles-types',
  GET_SERVICE_VEHICLES_ENUMS_KEY: 'service-vehicles-enums',
  GET_SERVICE_VEHICLES_BRANDS_KEY: 'service-vehicles-brands',
  GET_SERVICE_VEHICLE_COMMENTS_KEY: 'service-vehicle-comments',
  GET_SERVICE_VEHICLE_HISTORY_KEY: 'service-vehicle-history',
  GET_TRAFFIC_OFFENSES_KEY: 'traffic-offenses',
  GET_TRAFFIC_OFFENSES_TASK_KEY: 'traffic-offenses-task',
  GET_TRAFFIC_OFFENSES_SERVICE_POINTS_KEY: 'traffic-offenses-service-points',
  GET_ORDER_KEY: 'order',
  GET_ORDER_TRANSACTIONS_KEY: 'order-transactions',
  GET_SUBSCRIPTION_KEY: 'subscription',
  GET_SUBSCRIPTION_HISTORY_CHANGELOG_KEY: 'subscription-history-changelog',
  GET_SUBSCRIPTION_HISTORY_EMAIL_KEY: 'subscription-history-email',
  GET_SUBSCRIPTION_LINKED_ITEMS_KEY: 'subscription-linked-items',
  GET_SUBSCRIPTIONS_KEY: 'subscriptions',
  GET_EXPORT_DATA_KEY: 'export-data',
  GET_MAILBOX_THREAD: 'mailbox-thread',
  GET_MAIL: 'single-mail',
  GET_MAIL_HISTORY: 'single-mail-history',
  GET_ARNM_MAINTENANCE_TASKS_KEY: 'maintenance-tasks',
  GET_BOOKINGS_KEY: 'bookings',
  GET_BOOKINGS_ENUMS_KEY: 'bookings-enums',
  GET_SUBSCRIPTIONS_ENUMS_KEY: 'subscriptions-enums',
  GET_SUBSCRIPTION_BUNDLES_KEY: 'subscription-bundles',
  GET_SUBSCRIPTION_BUNDLES_CONFIG_KEY: 'subscription-bundles-config',
  GET_VIDEOS_KEY: 'videos',
  GET_FLEET_SOURCING_TYPES: 'fleet-sourcing-types',
  GET_FLEET_DEALERS: 'fleet-dealers',
  GET_FLEET_COLORS: 'fleet-colors',
  GET_BOOKING_KEY: 'booking',
  GET_BOOKING_USER_KEY: 'booking-user',
  GET_BOOKING_SMS_TEMPLATES_KEY: 'booking-sms-templates',
  GET_BUY_OUT_FILTERS: 'buy-out-filters',
  GET_BUY_OUT_TASK_DATA_KEY: 'buy-out-task-data',
  GET_GLOBAL_SEARCH_BAR_KEY: 'global-search',
  GET_B2B_ORDERS_KEY: 'b2b-orders',
  GET_B2B_ORDER_BOOKINGS_KEY: 'b2b-order-booking',
  GET_B2B_ORDER_KEY: 'b2b-order',
  GET_B2B_ALL_ORDERS_KEY: 'b2b-orders-all',
  GET_B2B_ALL_VEHICLES_KEY: 'b2b-orders-all-vehicles',
  GET_INSPECTION_CARS_KEY: 'inspection-cars',
  GET_HANDOVER_CARS_KEY: 'handover-cars',
  GET_MAILBOXES_KEY: 'mailboxes',
  GET_SELL_VEHICLES_KEY: 'sell-vehicles',
  GET_LOGISTICS_KEY: 'logistics',
  GET_LOGISTIC_KEY: 'logistic',
  GET_LOGISTICS_DRIVERS_KEY: 'logistics-drivers',
  GET_CUSTOMER_VEHICLES_KEY: 'customer-vehicles',
  GET_CUSTOMER_VEHICLES_ENUM_KEY: 'customer-vehicles-enums',
  GET_CUSTOMER_VEHICLE_KEY: 'customer-vehicle',
  GET_CUSTOMER_VEHICLE_USERS_KEY: 'customer-vehicle-users',
  GET_BUNDLE_TYPES: 'bundle-types',
  GET_BUNDLES: 'bundles',
  GET_USER_KEY: 'user',
  GET_USER_WITH_SUBS_KEY: 'user-with-subs',
  GET_USER_SUBSCRIPTIONS_KEY: 'user-subscriptions-key',
  GET_USER_BOOKINGS_KEY: 'user-bookings-key',
  GET_USER_CREDIT_SCORE_KEY: 'user-credit-score-key',
  GET_USER_SELL_REQUEST_KEY: 'user-sell-request-key',
  GET_USER_LEASING_BUYOUT_REQUEST_KEY: 'user-leasing-buyouts-key',
  GET_SUBSCRIPTION_CONTRACTS_KEY: 'subscription-contracts',
  GET_CONTRACTS_KEY: 'contracts',
  GET_VEHICLE_PRICING_KEY: 'vehicle-pricing',
  GET_FLEET_VEHICLES_KEY: 'fleet-vehicles',
  GET_FLEET_VEHICLES_ENUMS_KEY: 'fleet-vehicles-enums',
  GET_CATALOG_CAR_VEHICLES_KEY: 'catalog-car-vehicles',
  GET_EMAILS_KEY: 'emails',
  GET_EMAIL_TOTALS_KEY: 'email-totals',
  GET_CATALOG_EBIKES_VEHICLES_KEY: 'catalog-ebikes-vehicles',
  GET_ENUMS_KEY: 'enums',
  GET_SELL_VEHICLE_KEY: 'sell-vehicle',
  GET_SELL_VEHICLE_ENUMS_KEY: 'sell-vehicle-enums',
  GET_SELL_LEASE_VEHICLE_ENUMS_KEY: 'sell-lease-vehicle-enums',
  GET_SANTANDER_MODEL_OPTIONS_KEY: 'santander-model-options',
  GET_COMPETITION_VEHICLES_KEY: 'competition-vehicles',
  GET_RESERVATIONS_COMMENT_KEY: 'reservations-comments',
  GET_RESERVATION_COMMENTS_KEY: 'reservation-comments',
  GET_SUBSCRIPTION_ASSIGNEES_KEY: 'subscription-assignees',
  GET_CREDIT_CHECK_TABLE_KEY: 'credit-check-table',
  GET_GUARANTEE_RETURNS_KEY: 'guarantee-returns',
  GET_TRADE_VEHICLES_KEY: 'trade-vehicles',
  GET_TRADE_TICKETS_KEY: 'trade-tickets',
  GET_TRADE_TICKET_KEY: 'trade-ticket',
  GET_TRADE_TICKET_COMMENTS_KEY: 'trade-ticket-comments',
  GET_TRADE_TICKET_HISTORY_KEY: 'trade-ticket-history',
  GET_TRADE_TICKET_PRICING_KEY: 'trade-ticket-pricing',
  GET_TRADE_TICKET_DOCUMENTS_KEY: 'trade-ticket-documents',
  GET_VEHICLE_CHANGELOG_KEY: 'vehicle-changelog',
  GET_VEHICLE_INSURANCES_KEY: 'vehicle-insurances',
  GET_VEHICLE_ALL_SERVICE_POINTS_KEY: 'vehicle-all-service-points',
  GET_VEHICLE_ROAD_SIDE_ASSISTANCE_KEY: 'vehicle-roadside-assistance',
  GET_VEHICLE_COLORS_KEY: 'vehicle-colors',
  GET_VEHICLE_HISTORY_KEY: 'vehicle-history',
  GET_VEHICLE_DEALERS_KEY: 'vehicle-dealers',
  GET_VEHICLE_PROVIDERS_KEY: 'vehicle-providers',
  GET_VEHICLE_SERVICE_POINTS_KEY: 'vehicle-service-points',
  GET_VEHICLE_BY_ID_KEY: 'vehicle-by-id',
  GET_VEHICLE_SOURCING_TYPES_KEY: 'vehicle-sourcing-types',
  GET_MY_ISSUES_KEY: 'my-issues',
  GET_BOARDS_TASK_STATUSES_KEY: 'boards-task-statuses',
  GET_MY_BOARDS_KEY: 'my-boards',
  GET_EMAIL_TEMPLATES: 'email-templates',
  GET_EMAIL_TEMPLATE_KEY: 'email-template',
  GET_SUBSCRIPTION_SMS_TEMPLATES_KEY: 'subscription-sms-templates',
  GET_MY_ISSUES_MAILBOX_KEY: 'my-issues-mailbox',
  GET_VEHICLE_HISTORY_CHANGES_KEY: 'vehicle-history-changes',
  GET_GENERIC_TICKETS_KEY: 'generic-tickets',
  GET_GENERIC_TICKET_KEY: 'generic-ticket',
  GET_GENERIC_TICKET_COMMENTS_KEY: 'generic-ticket-comments',
  GET_GENERIC_TICKET_HISTORY_KEY: 'generic-ticket-history',
  GET_SELL_VEHICLES_B2B_KEY: 'sell-vehicles-b2b',
  GET_MARKETPLACE_TIRES_KEY: 'marketplace-tires',
  GET_MARKETPLACE_TIRES_FILTERS_KEY: 'marketplace-tires-filters',
  GET_FOR_SALE_VEHICLES_KEY: 'availability-sale',
  GET_USER_HISTORY_CHANGES_KEY: 'user-history-changes',
  GET_TICKET_CREATION_TEAMS_KEY: 'ticket-creation-teams',
  GET_FLEET_VEHICLES_COMMENTS_KEY: 'fleet-vehicles-comments',
  GET_USER_COMMENTS_KEY: 'user-comments',
  GET_BOOKING_HISTORY_CHANGES_KEY: 'booking-history-changes',
  GET_BOOKING_CHANGELOG_KEY: 'booking-changelog',
  GET_BOOKING_COMMENTS_KEY: 'booking-comments',
  GET_BOOKING_SMS_KEY: 'booking-sms',
  GET_BOOKING_EMAILS_KEY: 'booking-emails',
  GET_USER_SMS_KEY: 'user-sms',
  GET_PROCUREMENT_ORDERS: 'procurement-orders',
  GET_PROCUREMENT_ORDERS_SUPPLIERS: 'procurement-orders-suppliers',
  GET_PROCUREMENT_ORDER_KEY: 'procurement-order',
  GET_PROCUREMENT_ORDER_SUPPLIERS_KEY: 'procurement-order-suppliers',
  GET_PROCUREMENT_ORDER_VEHICLES_KEY: 'procurement-order-vehicles',
  GET_PROCUREMENT_ORDER_SKU_GROUP_ITEMS: 'procurement-order-sku-items',
  UPDATE_PROCUREMENT_ORDER_KEY: 'update-procurement-order',
  GET_PROCUREMENT_ORDER_AGENTS_KEY: 'procurement-order-agents',
  GET_SUBSCRIPTION_COMMENTS_KEY: 'subscription-comments',
  GET_SUBSCRIPTION_HISTORY_CHANGES_KEY: 'subscription-history-changes',
  GET_SUBSCRIPTION_HISTORY_SMS_KEY: 'subscription-history-sms',
  GET_CONTRACTS_ENUMS_KEY: 'contracts-enums',
  GET_BOOKING_LABELS_KEY: 'booking-labels',
  GET_EBIKE_KEY: 'ebike',
  GET_EBIKE_ENUMS_KEY: 'ebike-enums',
  GET_EBIKE_PROVIDERS_KEY: 'ebike-providers',
  GET_EBIKE_MODELS_KEY: 'ebike-models',
  GET_EBIKES_BY_SKU_KEY: 'ebikes-by-sku',
  GET_PROCUREMENT_ENUMS_KEY: 'procurement-enums',
  GET_SELL_VEHICLES_ENUMS_KEY: 'sell-vehicles-enums',
  GET_EMAIL_TEMPLATES_ENUMS_KEY: 'email-templates-enums',
  GET_LOGISTICS_ENUMS_KEY: 'logistics-enums',
  GET_USERS_ENUMS_KEY: 'users-enums',
  GET_BOARDS_TASK_ENUMS_KEY: 'boards-my-task-enums',
  GET_BOOKING_LINKED_TASKS_KEY: 'booking-linked-tasks',
  GET_MAIL_ENTITIES_KEY: 'mail-entities',
};
